export interface Video {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  year: number;
  rating: number;
  description: string;
  director: string;
  actors: string[];
  type: string;
  region: string;
  releaseDate: string;
  updateDate: string;
  views: number;
  tags: string[];
  featured: boolean;
  episodes?: number;
  currentEpisode?: number;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-grid-line', count: 48 },
  { name: '国产电影', slug: 'movie', icon: 'ri-film-line', count: 16 },
  { name: '国产电视剧', slug: 'tv', icon: 'ri-tv-line', count: 12 },
  { name: '国产综艺', slug: 'variety', icon: 'ri-live-line', count: 10 },
  { name: '纪录片', slug: 'documentary', icon: 'ri-slideshow-line', count: 6 },
  { name: '动漫', slug: 'anime', icon: 'ri-robot-line', count: 4 },
] as const;

export const featuredVideos: Video[] = [
  {
    id: 1,
    title: '长津湖',
    slug: 'changjin-hu',
    category: '国产电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20war%20film%20scene%20with%20soldiers%20in%20snowy%20mountain%20battlefield%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20film%20poster%20style%2C%20warm%20golden%20and%20cool%20blue%20contrast%2C%20professional%20movie%20photography&width=800&height=450&seq=video-featured-01&orientation=landscape',
    duration: '176分钟',
    year: 2021,
    rating: 9.2,
    description: '以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了一段波澜壮阔的历史：71年前，中国人民志愿军赴朝作战，在极寒严酷环境下，东线作战部队凭着钢铁意志和英勇无畏的战斗精神一路追击，奋勇杀敌，扭转了战场态势，打出了军威国威。',
    director: '陈凯歌、徐克、林超贤',
    actors: ['吴京', '易烊千玺', '段奕宏', '朱亚文', '李晨'],
    type: '战争/历史',
    region: '中国大陆',
    releaseDate: '2021-09-30',
    updateDate: '2024-06-15',
    views: 28560000,
    tags: ['战争', '历史', '爱国', '动作'],
    featured: true,
  },
  {
    id: 2,
    title: '你好，李焕英',
    slug: 'nihao-lihuanying',
    category: '国产电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20family%20comedy%20film%20scene%20with%20mother%20and%20daughter%20in%201980s%20China%2C%20nostalgic%20vintage%20setting%2C%20soft%20warm%20lighting%2C%20emotional%20and%20heartwarming%20atmosphere%2C%20film%20poster%20aesthetic&width=800&height=450&seq=video-featured-02&orientation=landscape',
    duration: '128分钟',
    year: 2021,
    rating: 9.0,
    description: '2001年的某一天，刚刚考上大学的贾晓玲经历了人生中的一次大起大落。一心想要成为母亲骄傲的她却因母亲突遭严重意外，而悲痛万分。在情绪崩溃的状态下，贾晓玲竟意外地回到了1981年，并与年轻的母亲李焕英相遇。',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾', '陈赫'],
    type: '喜剧/剧情',
    region: '中国大陆',
    releaseDate: '2021-02-12',
    updateDate: '2024-05-20',
    views: 32150000,
    tags: ['喜剧', '亲情', '穿越', '感动'],
    featured: true,
  },
  {
    id: 3,
    title: '狂飙',
    slug: 'kuangbiao',
    category: '国产电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20scene%20with%20intense%20police%20and%20gangster%20confrontation%2C%20dark%20and%20gritty%20urban%20setting%2C%20noir%20cinematography%2C%20suspenseful%20atmosphere%2C%20professional%20drama%20poster%20style&width=800&height=450&seq=video-featured-03&orientation=landscape',
    duration: '39集',
    year: 2023,
    rating: 9.5,
    description: '2000年，意气风发的刑警安欣与倍受欺负的鱼贩子高启强相识，而后随着高启强逐渐偏离正途，安欣意识到在京海市社会发展的背后正是以高家兄弟为首的黑恶势力暗流汹涌，两人分道扬镳并展开了长达20年的正邪较量。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    type: '犯罪/悬疑',
    region: '中国大陆',
    releaseDate: '2023-01-14',
    updateDate: '2024-06-10',
    views: 45200000,
    tags: ['犯罪', '悬疑', '扫黑', '剧情'],
    featured: true,
    episodes: 39,
    currentEpisode: 39,
  },
];

export const allVideos: Video[] = [
  ...featuredVideos,
  {
    id: 4,
    title: '流浪地球2',
    slug: 'liulang-diQiu-2',
    category: '国产电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20scene%20with%20futuristic%20space%20station%20and%20earth%20engines%2C%20epic%20cinematic%20scale%2C%20dramatic%20lighting%20with%20blue%20and%20orange%20contrast%2C%20professional%20movie%20poster%20quality&width=800&height=450&seq=video-04&orientation=landscape',
    duration: '173分钟',
    year: 2023,
    rating: 8.8,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    type: '科幻/冒险',
    region: '中国大陆',
    releaseDate: '2023-01-22',
    updateDate: '2024-05-30',
    views: 19800000,
    tags: ['科幻', '冒险', '特效', '宇宙'],
    featured: false,
  },
  {
    id: 5,
    title: '满江红',
    slug: 'manjianghong',
    category: '国产电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20film%20scene%20set%20in%20ancient%20courtyard%20with%20soldiers%20and%20lanterns%2C%20dark%20atmospheric%20night%20setting%2C%20traditional%20Chinese%20architecture%2C%20suspenseful%20cinematic%20lighting&width=800&height=450&seq=video-05&orientation=landscape',
    duration: '159分钟',
    year: 2023,
    rating: 8.5,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中，宰相秦桧命两人限一个时辰之内找到凶手。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    type: '悬疑/喜剧',
    region: '中国大陆',
    releaseDate: '2023-01-22',
    updateDate: '2024-04-18',
    views: 27500000,
    tags: ['悬疑', '喜剧', '历史', '古装'],
    featured: false,
  },
  {
    id: 6,
    title: '繁花',
    slug: 'fanhua',
    category: '国产电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20set%20in%201990s%20Shanghai%20with%20elegant%20characters%20in%20vintage%20fashion%2C%20neon%20lights%20and%20Bund%20skyline%2C%20nostalgic%20and%20stylish%20cinematography%2C%20warm%20golden%20tones&width=800&height=450&seq=video-06&orientation=landscape',
    duration: '30集',
    year: 2023,
    rating: 9.3,
    description: '九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀，黄河路上无人不晓。平凡阿宝蜕变为宝总，离不开高人爷叔与夜东京老板玲子、外贸大楼汪小姐的鼎力协助。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    type: '剧情/都市',
    region: '中国大陆',
    releaseDate: '2023-12-27',
    updateDate: '2024-06-12',
    views: 38600000,
    tags: ['剧情', '都市', '商战', '年代'],
    featured: false,
    episodes: 30,
    currentEpisode: 30,
  },
  {
    id: 7,
    title: '消失的她',
    slug: 'xiaoshi-de-ta',
    category: '国产电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Suspenseful%20Chinese%20thriller%20film%20scene%20with%20tropical%20island%20setting%2C%20mysterious%20atmosphere%2C%20couple%20on%20beach%20at%20sunset%2C%20dark%20and%20moody%20cinematography%2C%20film%20noir%20aesthetic&width=800&height=450&seq=video-07&orientation=landscape',
    duration: '121分钟',
    year: 2023,
    rating: 8.2,
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，在何非苦寻无果之时妻子再次现身，何非却坚称眼前的陌生女人并非妻子，妻子拿出了身份证明进行自证，夫妻二人似乎都有不可告人的秘密。',
    director: '崔睿、刘翔',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    type: '悬疑/犯罪',
    region: '中国大陆',
    releaseDate: '2023-06-22',
    updateDate: '2024-03-25',
    views: 21300000,
    tags: ['悬疑', '犯罪', '反转', '惊悚'],
    featured: false,
  },
  {
    id: 8,
    title: '三体',
    slug: 'santi',
    category: '国产电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20based%20on%20Three%20Body%20Problem%2C%20futuristic%20and%20mysterious%20atmosphere%2C%20scientific%20laboratory%20with%20cosmic%20elements%2C%20dark%20and%20intellectual%20cinematography&width=800&height=450&seq=video-08&orientation=landscape',
    duration: '30集',
    year: 2023,
    rating: 8.7,
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。离奇自杀的科学家，近乎神迹的倒计时，行事隐秘的科学边界，神秘莫测的《三体》游戏。纳米科学家汪淼被警官史强带到联合作战中心，并潜入名为"科学边界"的组织协助调查。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    type: '科幻/悬疑',
    region: '中国大陆',
    releaseDate: '2023-01-15',
    updateDate: '2024-06-01',
    views: 29800000,
    tags: ['科幻', '悬疑', '小说改编', '硬科幻'],
    featured: false,
    episodes: 30,
    currentEpisode: 30,
  },
  {
    id: 9,
    title: '奔跑吧·生态篇',
    slug: 'benpaoba-shengtai',
    category: '国产综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20with%20celebrities%20running%20and%20playing%20games%20in%20beautiful%20natural%20scenery%2C%20bright%20and%20energetic%20atmosphere%2C%20colorful%20and%20fun%20group%20shot&width=800&height=450&seq=video-09&orientation=landscape',
    duration: '12期',
    year: 2023,
    rating: 8.0,
    description: '《奔跑吧·生态篇》以生态文明建设为主题，兄弟团成员走进祖国大好河山，通过一系列趣味横生的游戏挑战，带领观众感受自然之美，传递环保理念。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '沙溢', '白鹿', '周深'],
    type: '真人秀/综艺',
    region: '中国大陆',
    releaseDate: '2023-11-18',
    updateDate: '2024-02-10',
    views: 15600000,
    tags: ['综艺', '真人秀', '户外', '游戏'],
    featured: false,
    episodes: 12,
    currentEpisode: 12,
  },
  {
    id: 10,
    title: '长安三万里',
    slug: 'changan-sanwanli',
    category: '国产电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20about%20Tang%20Dynasty%20poets%20in%20ancient%20Changan%20city%2C%20beautiful%20traditional%20Chinese%20art%20style%2C%20poetic%20and%20elegant%20atmosphere%2C%20warm%20golden%20and%20vermilion%20tones&width=800&height=450&seq=video-10&orientation=landscape',
    duration: '168分钟',
    year: 2023,
    rating: 8.9,
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。影片以动画形式展现了盛唐时期的诗人风采与家国情怀。',
    director: '谢君伟、邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    type: '动画/历史',
    region: '中国大陆',
    releaseDate: '2023-07-08',
    updateDate: '2024-05-05',
    views: 18900000,
    tags: ['动画', '历史', '唐诗', '国风'],
    featured: false,
  },
  {
    id: 11,
    title: '漫长的季节',
    slug: 'manchang-de-jijie',
    category: '国产电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20drama%20series%20set%20in%20northeastern%20China%20with%20autumn%20atmosphere%2C%20small%20town%20setting%2C%20retro%201990s%20vibe%2C%20melancholic%20and%20suspenseful%20cinematography&width=800&height=450&seq=video-11&orientation=landscape',
    duration: '12集',
    year: 2023,
    rating: 9.4,
    description: '小城桦林，出租司机王响做梦也没想到，他还有机会遇到一个此生最想遇到又最怕遇到的人。是仇人还是故人？遇到了就得有交代，给自己一个交代。一包身份未明的碎尸像一块石头砸在桦林的水面上，也砸在王响的头脑里。',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希'],
    type: '悬疑/剧情',
    region: '中国大陆',
    releaseDate: '2023-04-22',
    updateDate: '2024-06-08',
    views: 25800000,
    tags: ['悬疑', '剧情', '年代', '犯罪'],
    featured: false,
    episodes: 12,
    currentEpisode: 12,
  },
  {
    id: 12,
    title: '乘风破浪的姐姐·第四季',
    slug: 'chengfengpolang-4',
    category: '国产综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20variety%20show%20with%20female%20celebrities%20on%20stage%20performing%2C%20glamorous%20and%20fierce%20stage%20lighting%2C%20empowering%20atmosphere%2C%20professional%20studio%20photography&width=800&height=450&seq=video-12&orientation=landscape',
    duration: '12期',
    year: 2023,
    rating: 8.3,
    description: '《乘风破浪的姐姐》第四季延续前作,汇集33位30+女性艺人,通过封闭式训练与舞台竞演,展现成熟女性的无限可能,最终选拔出优胜者成团出道。',
    director: '任洋',
    actors: ['Ella', '谢娜', '蔡少芬', '龚琳娜', '贾静雯'],
    type: '音乐/真人秀',
    region: '中国大陆',
    releaseDate: '2023-05-05',
    updateDate: '2024-01-20',
    views: 22300000,
    tags: ['综艺', '音乐', '选秀', '女性'],
    featured: false,
    episodes: 12,
    currentEpisode: 12,
  },
  {
    id: 13,
    title: '飞驰人生2',
    slug: 'feichi-rensheng-2',
    category: '国产电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20film%20scene%20with%20cars%20on%20racetrack%20in%20desert%20landscape%2C%20dynamic%20action%20shot%2C%20warm%20desert%20colors%2C%20cinematic%20racing%20photography&width=800&height=450&seq=video-13&orientation=landscape',
    duration: '129分钟',
    year: 2024,
    rating: 8.4,
    description: '昔日冠军车手张驰沦为落魄驾校教练，过着靠脸吃饭勉强度日的生活。不料天上掉馅饼，濒临停产的老头乐车厂厂长主动提出赞助张驰组建车队再闯最后一届巴音布鲁克拉力赛。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
    type: '喜剧/运动',
    region: '中国大陆',
    releaseDate: '2024-02-10',
    updateDate: '2024-06-14',
    views: 16200000,
    tags: ['喜剧', '赛车', '励志', '动作'],
    featured: false,
  },
  {
    id: 14,
    title: '庆余年·第二季',
    slug: 'qingyunian-2',
    category: '国产电视剧',
    categorySlug: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20series%20with%20ancient%20palace%20setting%2C%20intricate%20costumes%2C%20political%20intrigue%20atmosphere%2C%20elegant%20and%20dramatic%20cinematography&width=800&height=450&seq=video-14&orientation=landscape',
    duration: '36集',
    year: 2024,
    rating: 9.1,
    description: '范闲从北齐归来后，发现自己已经被卷入更深的朝堂漩涡之中。面对二皇子的步步紧逼、长公主的暗中算计，以及庆帝的深不可测，范闲将如何在这个波谲云诡的京都中保全自己，同时为母亲叶轻眉复仇？',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    type: '古装/权谋',
    region: '中国大陆',
    releaseDate: '2024-05-16',
    updateDate: '2024-06-16',
    views: 42300000,
    tags: ['古装', '权谋', '小说改编', '剧情'],
    featured: false,
    episodes: 36,
    currentEpisode: 36,
  },
  {
    id: 15,
    title: '王牌对王牌·第八季',
    slug: 'wangpai-8',
    category: '国产综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20studio%20with%20celebrities%20competing%20in%20fun%20challenges%2C%20bright%20colorful%20stage%20lighting%2C%20energetic%20and%20humorous%20atmosphere&width=800&height=450&seq=video-15&orientation=landscape',
    duration: '12期',
    year: 2023,
    rating: 8.1,
    description: '经典综艺IP《王牌对王牌》第八季欢乐回归，王牌家族携手新成员，通过经典游戏与才艺比拼，为观众带来爆笑不断的娱乐盛宴。',
    director: '吴彤',
    actors: ['沈腾', '贾玲', '华晨宇', '关晓彤', '宋亚轩'],
    type: '游戏/真人秀',
    region: '中国大陆',
    releaseDate: '2023-10-20',
    updateDate: '2024-01-15',
    views: 19800000,
    tags: ['综艺', '游戏', '搞笑', '经典'],
    featured: false,
    episodes: 12,
    currentEpisode: 12,
  },
  {
    id: 16,
    title: '热辣滚烫',
    slug: 'relaguntang',
    category: '国产电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%20about%20boxing%20and%20self-transformation%2C%20gym%20training%20scene%20with%20determined%20female%20athlete%2C%20inspirational%20and%20warm%20atmosphere%2C%20cinematic%20portrait%20style&width=800&height=450&seq=video-16&orientation=landscape',
    duration: '129分钟',
    year: 2024,
    rating: 8.6,
    description: '乐莹是一个善良、单纯却总是被生活捉弄的女孩。在经历了一系列打击之后，她决定通过拳击来改变自己。在教练的帮助下，乐莹不仅找到了自己的人生方向，更收获了珍贵的友情与爱情。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    type: '喜剧/剧情',
    region: '中国大陆',
    releaseDate: '2024-02-10',
    updateDate: '2024-06-13',
    views: 18500000,
    tags: ['喜剧', '励志', '拳击', '自我成长'],
    featured: false,
  },
];

export const aboutInfo = {
  brandName: '91在线视频',
  founded: '2018年',
  slogan: '汇聚国产影视精华，畅享高清视听盛宴',
  introduction: '91在线视频成立于2018年，是国内领先的国产影视资源聚合平台。我们专注于为观众提供最新、最全、最高清的国产电影、电视剧、综艺节目等影视内容，致力于打造一个纯净、流畅、内容丰富的在线观影环境。',
  mission: '让每一位观众都能方便快捷地观看到优质的国产影视作品，传承和弘扬中国影视文化。',
  vision: '成为中国最具影响力的国产影视内容聚合平台。',
  values: [
    { title: '内容为王', desc: '持续更新最新国产影视资源，覆盖电影、电视剧、综艺、纪录片等全品类内容。' },
    { title: '用户体验', desc: '高清画质、流畅播放、简洁界面，为用户提供极致的观影体验。' },
    { title: '合法合规', desc: '严格遵守版权法规，所有内容均来自正规授权渠道。' },
    { title: '技术驱动', desc: '持续投入技术研发，优化视频播放与内容推荐算法。' },
  ],
  achievements: [
    { number: '5000万+', label: '月活跃用户' },
    { number: '10万+', label: '影视资源' },
    { number: '99.9%', label: '服务可用率' },
    { number: '4.8/5', label: '用户满意度' },
  ],
  contact: {
    email: 'contact@91onlinevideo.com',
    phone: '400-888-9191',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    wechat: '91zaixianshipin',
    weibo: '@91在线视频官方',
  },
};

export const faqs = [
  {
    question: '91在线视频是否需要注册才能观看？',
    answer: '不需要。91在线视频所有影视内容均免费在线观看，无需注册登录，即点即看。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '我们的视频采用先进的CDN加速技术，支持自适应码率。如果遇到卡顿，建议检查您的网络连接，或切换到较低清晰度观看。',
  },
  {
    question: '是否有移动端App？',
    answer: '我们的网站采用响应式设计，完美适配手机、平板等移动设备。您可以直接通过浏览器访问，无需下载App。',
  },
  {
    question: '视频更新频率如何？',
    answer: '我们每天都会更新最新上线的国产影视内容，确保您能第一时间观看到最新的电影、电视剧和综艺节目。',
  },
  {
    question: '如何反馈问题或提出建议？',
    answer: '您可以通过关于我们页面的联系方式与我们取得联系，也可以通过邮箱 contact@91onlinevideo.com 发送反馈，我们会尽快回复。',
  },
];